<template>
  <div>
    <div class="d-flex align-items-start">
      <b-icon :icon="titleIcon" :variant="variant" class="mr-2 mt-1"></b-icon>
      <div>
        <!-- Title -->
        <div class="font-weight-bold" :class="`text-${variant}`">
          {{ title }}
        </div>

        <!-- Jeu -->
        <div class="ml-2">
          <div class="font-weight-bold">{{ game.name }}</div>
          <div v-if="showDetails" class="text-muted small">
            <!-- Nombre de manches -->
            <div v-if="hasHandles">
              <b-icon-check-circle-fill
                class="text-success mr-0"
              ></b-icon-check-circle-fill>
              {{ game.handles.length }} manches
            </div>
            <div v-else class="text-danger">
              <b-icon-x-circle-fill class="text-danger"></b-icon-x-circle-fill>
              Pas de manche
            </div>

            <!-- Contient un handle score_final -->
            <div v-if="hasScoreFinalHandle">
              <b-icon-check-circle-fill
                class="text-success mr-0"
              ></b-icon-check-circle-fill>
              Contient une manche "Score Final"
            </div>
            <div v-else class="text-danger">
              <b-icon-x-circle-fill class="text-danger"></b-icon-x-circle-fill>
              Aucune manche "Score Final"
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      variant: {
        type: String,
        default: 'info',
      },
      titleClass: {
        type: String,
        default: 'text-info',
      },
      titleIcon: {
        type: String,
        default: 'info-circle-fill',
      },
      game: {
        type: Object,
        required: true,
      },
      showDetails: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      hasHandles() {
        return this.game.handles?.length > 0
      },
      hasScoreFinalHandle() {
        return this.game.handles?.some(
          (handle) => handle.type === 'Score Final'
        )
      },
    },
  }
</script>
